<template>
  <!-- a switch for keyboards and screen readers too (2026-10-14): role, state, Space/Enter -->
  <span
    :class="['switch', {isEnabled, secondaryColor}]"
    role="switch"
    tabindex="0"
    :aria-checked="isEnabled ? 'true' : 'false'"
    :aria-label="label || undefined"
    @click="toggle"
    @keydown.space.prevent="toggle"
    @keydown.enter.prevent="toggle">
    <span class="circle"/>
  </span>
</template>

<script setup>
import {nextTick} from "vue";
import {useLog} from "@/composables/useLog";

const log = useLog("AppSwitch");
// label: its accessible name (screen readers); the visible text beside it, as a rule
defineProps({secondaryColor: Boolean, label: {type: String, default: ""}});
const isEnabled = defineModel();

async function toggle() {
  const nextValue = !isEnabled.value;
  log(`toggle(): was=${isEnabled.value}, next=${nextValue}`);
  isEnabled.value = nextValue;
  await nextTick();
  log(`toggle(): afterTick=${isEnabled.value}`);
}
</script>

<style scoped>
.switch {
  --pill-width: 38px;
  --pill-height: 22px;
  --circle-size: 18px;
  flex: 0 0 auto;
  width: var(--pill-width) !important;
  height: var(--pill-height);
  border-radius: calc(var(--pill-height) / 2);
  background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  padding: 0;
  position: relative;
  transition: background-color 0.3s;
}
.circle {
  width: var(--circle-size);
  height: var(--circle-size);
  background-color: #fff;
  border-radius: 50%;
  margin-left: 1px;
  transform: translateX(0);
  transition: transform 0.3s;
}
.switch.isEnabled {
  background-color: var(--brand-color);
}
.switch.isEnabled.secondaryColor {
  background-color: var(--brand-color-secondary);
}
.switch.isEnabled .circle {
  transform: translateX(calc(var(--pill-width) - var(--circle-size) - 2px));
}
.switch:focus-visible {
  outline: 2px solid var(--brand-color);
  outline-offset: 2px;
}
</style>
